import { render, staticRenderFns } from "./NotificationDate.vue?vue&type=template&id=21bb68cc"
import script from "./NotificationDate.vue?vue&type=script&lang=js"
export * from "./NotificationDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports